var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "PortalWidget",
    {
      attrs: { widget: _vm.widget },
      scopedSlots: _vm._u([
        {
          key: "headerContent",
          fn: function() {
            return [
              _c("div", { staticClass: "header-extra" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.filters.name.value,
                      expression: "filters.name.value"
                    }
                  ],
                  staticClass:
                    "form-control input-md widget-header-input m-r-10",
                  attrs: {
                    type: "search",
                    placeholder: _vm.$t("API_TOKENS_SEARCH_PH")
                  },
                  domProps: { value: _vm.filters.name.value },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.filters.name, "value", $event.target.value)
                    }
                  }
                })
              ])
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _vm._v(" "),
      !_vm.isFetchingTokens
        ? _c("div", { staticClass: "m-t-10 m-b-15" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-success btn-sm m-r-5",
                attrs: { type: "button", disabled: _vm.showCreateForm },
                on: { click: _vm.onShowCreateForm }
              },
              [
                _c("i", { staticClass: "fa fa-plus" }),
                _vm._v(" "),
                _c("span", {
                  directives: [
                    {
                      name: "t",
                      rawName: "v-t",
                      value: "API_TOKENS_ADD_BUTTON",
                      expression: "'API_TOKENS_ADD_BUTTON'"
                    }
                  ]
                })
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.isFetchingTokens
        ? _c(
            "div",
            { staticClass: "grid_table_holder" },
            [
              _c(
                "v-table",
                {
                  staticClass: "table_beauty",
                  attrs: {
                    data: _vm.apiTokensList,
                    "current-page": _vm.currentPage,
                    filters: _vm.filters,
                    "page-size": 20,
                    "hide-sort-icons": true
                  },
                  on: {
                    "update:currentPage": function($event) {
                      _vm.currentPage = $event
                    },
                    "update:current-page": function($event) {
                      _vm.currentPage = $event
                    },
                    totalPagesChanged: function($event) {
                      _vm.totalPages = $event
                    }
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "body",
                        fn: function({ displayData }) {
                          return _c(
                            "tbody",
                            {},
                            [
                              !_vm.showCreateForm && !_vm.apiTokensList.length
                                ? _c("tr", [
                                    _c("td", {
                                      directives: [
                                        {
                                          name: "t",
                                          rawName: "v-t",
                                          value: "API_TOKENS_HEADER_NONE",
                                          expression: "'API_TOKENS_HEADER_NONE'"
                                        }
                                      ],
                                      attrs: { colspan: "100" }
                                    })
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.showCreateForm
                                ? _c(
                                    "tr",
                                    {
                                      staticClass:
                                        "row-inline-new-form slide-down bg-row-even"
                                    },
                                    [
                                      _c(
                                        "td",
                                        { attrs: { colspan: "100" } },
                                        [
                                          _c("ApiTokenForm", {
                                            on: {
                                              "create-api-token":
                                                _vm.onOpenCreateAuthModal,
                                              "close-api-token-form":
                                                _vm.hideCreateForm
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm._l(displayData, function(row, index) {
                                return [
                                  !(
                                    _vm.isMobile &&
                                    _vm.activeActionRowId == row.tokenId
                                  )
                                    ? _c(
                                        "tr",
                                        {
                                          key: row.tokenId,
                                          class: {
                                            "bg-row-odd": index % 2 === 0,
                                            "bg-row-even": index % 2 !== 0
                                          }
                                        },
                                        [
                                          _vm.isMobile
                                            ? _c("td", [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "btn btn-list-function btn-expand-actions",
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.displayMobileAction(
                                                          row.tokenId
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fa fa-ellipsis-v"
                                                    })
                                                  ]
                                                )
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              "\n              " +
                                                _vm._s(row.name) +
                                                "\n            "
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              "\n              " +
                                                _vm._s(
                                                  row.usage[0] &&
                                                    row.usage[0].loginTime
                                                    ? row.usage[0].loginTime
                                                    : "-"
                                                ) +
                                                "\n            "
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              "\n              " +
                                                _vm._s(
                                                  row.usage[0] &&
                                                    row.usage[0]
                                                      .protectedResource
                                                    ? row.usage[0]
                                                        .protectedResource
                                                    : "-"
                                                ) +
                                                "\n            "
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              "\n              " +
                                                _vm._s(
                                                  row.usage[0] &&
                                                    row.usage[0].ipAddress
                                                    ? row.usage[0].ipAddress
                                                    : "-"
                                                ) +
                                                "\n            "
                                            )
                                          ]),
                                          _vm._v(" "),
                                          !_vm.isMobile
                                            ? _c(
                                                "td",
                                                [
                                                  _c("ApiTokenActions", {
                                                    attrs: {
                                                      "current-api-token": row,
                                                      disabled: _vm.disabled
                                                    },
                                                    on: {
                                                      deleteApiToken:
                                                        _vm.onShowDeleteApiTokenModal,
                                                      showApiTokenUsage: function(
                                                        $event
                                                      ) {
                                                        return _vm.onShowUsage(
                                                          row.tokenId
                                                        )
                                                      }
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.isMobile &&
                                  _vm.activeActionRowId == row.tokenId
                                    ? _c(
                                        "tr",
                                        {
                                          key: row.tokenId + "-mobile",
                                          staticClass:
                                            "mobile-actions slide-right"
                                        },
                                        [
                                          _c(
                                            "td",
                                            { attrs: { colspan: "10" } },
                                            [
                                              _c("ApiTokenActions", {
                                                attrs: {
                                                  "current-api-token": row,
                                                  disabled: _vm.disabled
                                                },
                                                on: {
                                                  collapseActions: function(
                                                    $event
                                                  ) {
                                                    !_vm.disabled &&
                                                      _vm.hideMobileAction()
                                                  },
                                                  deleteApiToken:
                                                    _vm.onShowDeleteApiTokenModal,
                                                  showApiTokenUsage: function(
                                                    $event
                                                  ) {
                                                    return _vm.onShowUsage(
                                                      row.tokenId
                                                    )
                                                  }
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.showUsage(row.tokenId)
                                    ? _c(
                                        "tr",
                                        {
                                          key: row.tokenId + "-usage",
                                          staticClass:
                                            "row-inline-new-form slide-down bg-row-even"
                                        },
                                        [
                                          _c(
                                            "td",
                                            { attrs: { colspan: "100" } },
                                            [
                                              _c("ApiTokenUsage", {
                                                attrs: { usage: row.usage },
                                                on: { hideUsage: _vm.hideUsage }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              })
                            ],
                            2
                          )
                        }
                      }
                    ],
                    null,
                    false,
                    4268227039
                  )
                },
                [
                  _c("thead", { attrs: { slot: "head" }, slot: "head" }, [
                    _c(
                      "tr",
                      [
                        _vm.isMobile ? _c("th") : _vm._e(),
                        _vm._v(" "),
                        _c("v-th", {
                          directives: [
                            {
                              name: "t",
                              rawName: "v-t",
                              value: "API_TOKENS_NAME",
                              expression: "'API_TOKENS_NAME'"
                            }
                          ],
                          attrs: { "default-sort": "asc", "sort-key": "name" }
                        }),
                        _vm._v(" "),
                        _c("v-th", {
                          directives: [
                            {
                              name: "t",
                              rawName: "v-t",
                              value: "API_TOKENS_LAST_DATE",
                              expression: "'API_TOKENS_LAST_DATE'"
                            }
                          ],
                          attrs: { "sort-key": "usage[0].loginTime" }
                        }),
                        _vm._v(" "),
                        _c("v-th", {
                          directives: [
                            {
                              name: "t",
                              rawName: "v-t",
                              value: "API_TOKENS_LAST_RESOURCE",
                              expression: "'API_TOKENS_LAST_RESOURCE'"
                            }
                          ],
                          attrs: { "sort-key": "usage[0].protectedResource" }
                        }),
                        _vm._v(" "),
                        _c("v-th", {
                          directives: [
                            {
                              name: "t",
                              rawName: "v-t",
                              value: "API_TOKENS_LAST_IP",
                              expression: "'API_TOKENS_LAST_IP'"
                            }
                          ],
                          attrs: { "sort-key": "usage[0].ipAddress" }
                        }),
                        _vm._v(" "),
                        !_vm.isMobile
                          ? _c("th", {
                              directives: [
                                {
                                  name: "t",
                                  rawName: "v-t",
                                  value: "TABLE_COL_ACTIONS",
                                  expression: "'TABLE_COL_ACTIONS'"
                                }
                              ]
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _vm.apiTokensList && _vm.apiTokensList.length
                ? _c("div", { staticClass: "pagination-min" }, [
                    _c(
                      "div",
                      { staticClass: "text-center p-7" },
                      [
                        _c("smart-pagination", {
                          attrs: {
                            "current-page": _vm.currentPage,
                            "total-pages": _vm.totalPages,
                            "max-page-links": 7
                          },
                          on: {
                            "update:currentPage": function($event) {
                              _vm.currentPage = $event
                            },
                            "update:current-page": function($event) {
                              _vm.currentPage = $event
                            }
                          }
                        })
                      ],
                      1
                    )
                  ])
                : _vm._e()
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "text-center empty-records" },
            [
              _c("Loader"),
              _vm._v(" "),
              _c("span", {
                directives: [
                  {
                    name: "t",
                    rawName: "v-t",
                    value: "API_TOKENS_HEADER_LOADING",
                    expression: "'API_TOKENS_HEADER_LOADING'"
                  }
                ]
              })
            ],
            1
          ),
      _vm._v(" "),
      _vm.showDeleteModal
        ? _c("ApiTokenDeleteModal", {
            attrs: {
              "api-token": _vm.apiTokenToBeDeleted,
              "is-loading": _vm.isDeletingToken
            },
            on: {
              "confirm-token-modal": _vm.onOpenDeleteAuthModal,
              "close-delete-token-modal": _vm.onCloseDeleteModal
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showMFAModal
        ? _c("MultiFactorAuthModal", {
            attrs: {
              model: _vm.mfaModel,
              "is-loading": _vm.isDeletingToken || _vm.isCreatingToken
            },
            on: {
              "confirm-modal": _vm.onConfirmMFAModal,
              "close-modal": _vm.onCancelAuthModal
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }